import { render, staticRenderFns } from "./Assign-interim-reviewer.vue?vue&type=template&id=261a8d78"
import script from "./Assign-interim-reviewer.vue?vue&type=script&lang=js"
export * from "./Assign-interim-reviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports